import {
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
  HttpEvent,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { LoadingController } from '@ionic/angular';

@Injectable()
export class LoaderInterceptor implements HttpInterceptor {
  private loader: HTMLIonLoadingElement | null = null;
  private httpCallStack = 0;
  private timeoutHandle: any;
  private blockedLoaderRoutes: string[] = [
    'api/v0/auth/alive',
    'api/v0/binary/construction-day-report/content',
    'api/v0/binary/hour-overview/content',
    'api/v0/binary/inspection/content',
    'api/v0/company/getLastDataUpdates',
    'api/v0/binary/document/previewImage',
  ];
  constructor(private loadingController: LoadingController) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    var routeBlocked = false;
    this.blockedLoaderRoutes.forEach((x) => {
      if (request.url.includes(x)) routeBlocked = true;
    });
    if (!routeBlocked) {
      this.showLoader();
    }

    return next.handle(request).pipe(finalize(() => this.hideLoader()));
  }

  private async showLoader() {
    //console.log('showLoader called, httpCallStack: ' + this.httpCallStack);
    this.httpCallStack++;
    if (this.httpCallStack > 1) {
      return;
    }
    //console.log('document hidden: ' + document.hidden);
    if (!this.loader && !document.hidden) {
      // Only show loader when tab is focused
      this.loader = await this.loadingController.create({
        spinner: 'circular',
        backdropDismiss: false,
      });
      await this.loader.present();

      this.timeoutHandle = setTimeout(() => {
        //this.forceCloseLoader();
      }, 10000);
    }
  }

  private async hideLoader() {
    //console.log('hideLoader called, httpCallStack: ' + this.httpCallStack);
    this.httpCallStack--;
    if (this.httpCallStack <= 0) {
      this.httpCallStack = 0;
      if (this.loader) {
        const loader = this.loader;
        this.loader = null;
        try {
          await loader?.dismiss().catch(() => {});
          await loader?.dismiss().catch(() => {});
          loader?.remove();
        } catch {}
      } else {
        //console.log('loader is not here');
      }
    }
  }

  private async forceCloseLoader() {
    if (this.loader) {
      console.log('Loader close forced');
      try {
        await this.loader.dismiss().catch(() => {});
      } catch (e) {
        // Ignorieren, falls Ionic schon geschlossen hat
      } finally {
        this.loader = null;
      }
    }

    // Timeout zurücksetzen, falls noch aktiv
    if (this.timeoutHandle) {
      clearTimeout(this.timeoutHandle);
      this.timeoutHandle = null;
    }
  }
}
